<template>
  <div class="otherTable">
    <OACard>
      <el-tabs v-model="type" type="card">
        <el-tab-pane label="劳动合同" name="Contract" v-if="contract">
          <el-button class="tabBtn" size="medium" @click="showModal">
            <i class="el-icon-plus"></i>劳动合同
          </el-button>
          <d2-crud
            ref="contract"
            :columns="contractColumns"
            :data="contractTable"
            :options="options"
            :rowHandle="contractHandle"
            @custom-emit="showModal"
            @custom-del="deleteRow"
            @custom-fei="zuofei"
          />
        </el-tab-pane>
        <el-tab-pane name="Family">
          <span slot="label">
            <i style="color:red" v-if="!contract">*</i> 家庭成员
          </span>
          <el-button class="tabBtn" size="medium" @click="showModal">
            <i class="el-icon-plus"></i>家庭成员
          </el-button>
          <d2-crud
            ref="family"
            :columns="familyColumns"
            :data="familyTable"
            :options="options"
            :rowHandle="familyHandle"
            @custom-emit="showModal"
            @custom-del="deleteRow"
          />
        </el-tab-pane>
        <el-tab-pane name="Educate">
          <span slot="label">
            <i style="color:red" v-if="!contract">*</i> 教育信息
          </span>
          <el-button class="tabBtn" size="medium" @click="showModal">
            <i class="el-icon-plus"></i>教育信息
          </el-button>
          <d2-crud
            ref="educate"
            :columns="educateColumns"
            :data="educateTable"
            :options="options"
            :rowHandle="educateHandle"
            @custom-emit="showModal"
            @custom-del="deleteRow"
          />
        </el-tab-pane>
        <el-tab-pane label="工作经历" name="Work">
          <el-button class="tabBtn" size="medium" @click="showModal">
            <i class="el-icon-plus"></i>工作经历
          </el-button>
          <d2-crud
            ref="work"
            :columns="workColumns"
            :data="workTable"
            :options="options"
            :rowHandle="workHandle"
            @custom-emit="showModal"
            @custom-del="deleteRow"
          />
        </el-tab-pane>
      </el-tabs>
    </OACard>
    <OACard>
      <el-tabs v-model="type2" type="card">
        <el-tab-pane label="面试评价" name="Evaluate">
          <el-button class="tabBtn" size="medium" @click="showModal2" v-if="evaluate">
            <i class="el-icon-plus"></i>面试评价
          </el-button>
          <d2-crud
            ref="evaluate"
            :columns="evaluateColumns"
            :data="evaluateTable"
            :options="options"
            :rowHandle="evaluateHandle"
            @custom-emit="showModal2"
          />
        </el-tab-pane>
      </el-tabs>
    </OACard>
    <OAModalForm
      :title="title"
      :visible.sync="dialogVisible"
      :form-data="formData"
      @on-submit="submit"
      @on-cancel="dialogVisible=false"
      :labelWidth="type=='Contract'&&'160px'"
    ></OAModalForm>
  </div>
</template>
<script>
import d2Crud from "@d2-projects/d2-crud";
import api from "@/services/otherTable.js";
import OAModalForm from "@/components/OAModalForm/OAModalForm";
import { resFilter, getUrlQuery } from "@/common/util.js";
import formData from "./formData.js";
import columns from "./columns.js";
import OACard from "@/components/OACard/OACard";

export default {
  name: "otherTable",
  props: {
    evaluate: { default: true },
    contract: { default: true },
    userId: { default: null }
  },
  components: { OAModalForm, d2Crud,OACard },
  data() {
    return {
      options: {
        border: true,
        stripe: true,
        size: "medium"
      },
      contractColumns: columns.contractColumns,
      familyColumns: columns.familyColumns,
      educateColumns: columns.educateColumns,
      workColumns: columns.workColumns,
      evaluateColumns: columns.evaluateColumns,
      contractHandle: columns.contractHandle,
      familyHandle: columns.familyHandle,
      educateHandle: columns.educateHandle,
      workHandle: columns.workHandle,
      evaluateHandle: this.evaluate ? columns.evaluateHandle : null,
      contractTable: [], //劳动合同
      familyTable: [], //家庭成员
      educateTable: [], //教育信息
      workTable: [], //工作信息
      evaluateTable: [], //面试评价
      type: "Contract",
      type2: "Evaluate",
      title: "",
      dialogVisible: false,
      formData: {},
      id: "",
      query: {}
    };
  },
  watch: {
    contract: {
      handler: function(val, oldVal) {
        if (!val) {
          this.type = "Family";
        }
      },
      deep: true,
      immediate: true
    },
    userId: {
      handler: function(val, oldVal) {
        if (val) {
          this.getEducate();
          this.getFamily();
          this.getWork();
          this.getContract();
          this.getEvaluate();
        }
      },
      deep: true,
      immediate: true
    }
  },
  mounted() {
    this.query = getUrlQuery();
    this.query.type && this.showModal2();
  },
  methods: {
    async getEducate() {
      let res = await api.getEducate({ id: this.userId });
      this.educateTable = res.data.data;
    },
    async getFamily() {
      let res = await api.getFamily({ id: this.userId });
      this.familyTable = res.data.data;
    },
    async getWork() {
      let res = await api.getWork({ id: this.userId });
      this.workTable = res.data.data;
    },
    async getContract() {
      let res = await api.getContract({ id: this.userId });
      this.contractTable = res.data.data;
    },
    async getEvaluate() {
      let res = await api.getEvaluate({ id: this.userId });
      this.evaluateTable = res.data.data;
    },
    showModal(data) {
      this.dialogVisible = true;
      this.id = data && data.row ? data.row.id : "";
      switch (this.type) {
        case "Educate":
          this.title = "教育信息";
          this.formData = formData.educate(data);
          break;
        case "Family":
          this.title = "家庭成员";
          this.formData = formData.family(data);
          break;
        case "Work":
          this.title = "工作经历";
          this.formData = formData.work(data);
          break;
        case "Contract":
          this.title = "劳动合同";
          this.formData = formData.contract(data);
          break;
      }
    },
    showModal2(data) {
      this.title = "面试评价";
      this.dialogVisible = true;
      this.id = data && data.row ? data.row.id : "";
      this.formData = formData.evaluate(data);
    },
    async submit(val) {
      let res;
      if (this.title == "面试评价") {
        this.submit2(val);
      } else {
        if (val.invalidReason) {
          res = await api.cancelContract({
            employeeId: this.userId,
            id: this.id,
            invalidReason: val.invalidReason
          });
        } else {
          if (val.time) {
            val["startTime"] = val.time[0] + " 00:00:00";
            val["endTime"] = val.time[1] + " 00:00:00";
          }
          if(val.noLimitStartTime) {
            val['noLimitStartTime'] = val['noLimitStartTime'] + " 00:00:00";
          }
          val["employeeId"] = this.userId;
          delete val.time;
          if (this.id) {
            val["id"] = this.id;
            res = await api["edit" + this.type](val);
          } else {
            res = await api["add" + this.type](val);
          }
        }
        this.dialogVisible = false;
        resFilter(res, this["get" + this.type]());
      }
    },
    async submit2(val) {
      //面试评价
      let res;
      val["employeeId"] = this.userId;
      if (this.id) {
        val["id"] = this.id;
        res = await api.editEvaluate(val);
      } else {
        res = await api.addEvaluate(val);
      }
      this.dialogVisible = false;
      resFilter(res, this.getEvaluate());
    },
    deleteRow(data) {
      this.$confirm("此操作将永久删除该条记录", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let res = await api["del" + this.type]({ id: data.row.id });
          resFilter(res, this["get" + this.type]());
        })
        .catch(() => {});
    },
    zuofei(data) {
      this.id = data.row.id;
      this.title = "作废劳动合同";
      this.dialogVisible = true;
      this.formData = {
        contractCode: {
          formType: "a-span",
          label: "合同编码：",
          value: data.row.contractCode
        },
        nature: {
          formType: "a-span",
          label: "合同属性：",
          value: data.row.natureName
        },
        companyId: {
          formType: "a-span",
          label: "所属公司：",
          value: data.row.companyName
        },
        attribution: {
          formType: "a-span",
          label: "劳动关系所在地区：",
          value: data.row.attributionName
        },
        time: {
          formType: "a-span",
          label: "合同时间：",
          type: "daterange",
          value:
            data.row.startTime.split(" ")[0] +
            " 至 " +
            data.row.endTime.split(" ")[0]
        },
        station: {
          formType: "a-span",
          label: "合同岗位：",
          value: data.row.station
        },
        invalidReason: {
          formType: "a-select",
          label: "作废原因：",
          value: undefined,
          code: 123,
          options: [],
          rules: [
            {
              required: true,
              message: "请选择作废原因",
              trigger: "change"
            }
          ]
        }
      };
    }
  }
};
</script>
<style lang="scss">
.otherTable {
  .el-tabs--card > .el-tabs__header {
    border-bottom: none;
  }
  .el-tabs__header {
    margin: 0px;
  }
  .el-tabs__content {
    overflow: visible;
    .d2-crud .d2-crud-body {
      padding: 0px;
      .el-button {
        padding: 0px;
        border: none;
        &.el-button--danger {
          background-color: transparent;
          color: #f56c6c;
        }
        &.el-button--primary {
          background-color: transparent;
          color: #409eff;
        }
        &.el-button--warning {
          background-color: transparent;
          color: #e6a23c;
        }
      }
    }
  }
  .tabBtn {
    position: absolute;
    top: -40px;
    right: 0;
  }
}
</style>





// WEBPACK FOOTER //
// src/components/otherTable/otherTable.vue